



































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';

@Component({})
export default class DocumentInfo extends Vue {
  @PropSync('documentSync', {}) documents!: [];
}

